import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

export const ModalContainer = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  width: 720px;
  max-width: 90vw;
  max-height: 80vh;
  overflow: auto;
`;

export const Title = styled.h3`
  margin: 0 0 4px;
  font-size: 18px;
`;

export const Subtitle = styled.p`
  margin: 0 0 16px;
  font-size: 13px;
  color: #666;
`;

export const EmptyState = styled.div`
  padding: 20px;
  text-align: center;
  color: #666;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;

export const Th = styled.th`
  padding: 8px 6px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  text-align: left;
  color: #888;
`;

export const Td = styled.td`
  padding: 8px 6px;
  border-bottom: 1px solid #f3f3f3;
`;

export const ItemRow = styled.tr<{ $inelegivel?: boolean }>`
  opacity: ${({ $inelegivel }) => ($inelegivel ? 0.6 : 1)};
`;

export const MotivoInelegibilidade = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 11px;
  font-style: italic;
  color: #999;
`;

export const DescricaoRiscada = styled.span`
  text-decoration: line-through;
`;

export const BadgesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
`;

export const BadgePendencia = styled.span<{ $bloqueante?: boolean }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  white-space: nowrap;
  cursor: default;
  background-color: ${({ $bloqueante }) => ($bloqueante ? '#FCE8E6' : '#FDF3DC')};
  color: ${({ $bloqueante }) => ($bloqueante ? '#B3261E' : '#9A6A00')};
`;

export const ValorFixo = styled.span`
  display: inline-block;
  min-width: 90px;
  text-align: right;
  font-size: 13px;
  color: #333;
  font-variant-numeric: tabular-nums;
`;

export const Legenda = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 10px;
  font-size: 11px;
  color: #777;
`;

export const LegendaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

export const LegendaDot = styled.span<{ $bloqueante?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $bloqueante }) => ($bloqueante ? '#B3261E' : '#D19C00')};
`;

export const QtyInput = styled.input`
  width: 70px;
  min-width: 70px;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #ddd;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const ValueInput = styled.input`
  width: 130px;
  min-width: 130px;
  box-sizing: border-box;
  padding: 4px 10px;
  text-align: right;
  border-radius: 6px;
  border: 1px solid #ddd;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;

export const OutlineButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #0090d3;
  background: #fff;
  color: #0090d3;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  background: #0090d3;
  color: #fff;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
